import { styled } from 'parkdepot-shared/theme'

export const LinkContainer = styled('div', ({ $theme }) => ({
    marginTop: $theme.sizing.scale600
}))

export const Subtitle = styled('p', ({ $theme }) => ({
    ...$theme.typography.ParagraphSmall,
    marginBottom: 0
}))
